import { RouteContext } from './RouteContext';

import type { ClientRouteContextValue } from '../types';
import type { ReactNode } from 'react';

export interface MemoryRouteProviderProps {
  children: ReactNode;
  routes: ClientRouteContextValue;
}

export function MemoryRouteProvider({
  routes,
  children,
}: MemoryRouteProviderProps) {
  return (
    <RouteContext.Provider value={routes}>{children}</RouteContext.Provider>
  );
}
